module.exports = __webpack_public_path__ + "img/hamburger.e18516cd.svg";